import React from 'react'
import { CurrencyText } from '../../../Global'

export const TableDataCellCpc = ({ dataValue }: { dataValue?: number }) => {
  return <CurrencyText value={Number(dataValue)} />
}
